
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import TopBar from './TopBar.vue';
	import Footer from './Footer.vue';

	@Component({
		components: {
			TopBar,
			Footer,
		},
	})
	export default class Layout extends BaseView {

	}

